import { render, staticRenderFns } from "./Sticker.vue?vue&type=template&id=0d83b064&scoped=true"
import script from "./Sticker.vue?vue&type=script&lang=js"
export * from "./Sticker.vue?vue&type=script&lang=js"
import style0 from "./Sticker.vue?vue&type=style&index=0&id=0d83b064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d83b064",
  null
  
)

export default component.exports